const baseStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  padding: '10px 24px',
  background: '#FFFFFF',
  color: '#1F1F1F',
  border: '1px solid #747775',
  borderRadius: 4,
  fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, sans-serif",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  textDecoration: 'none',
  cursor: 'pointer',
  minHeight: 40,
  boxSizing: 'border-box',
};

/**
 * Sign in / Sign up with Google button per Google Identity branding guidelines.
 * Light theme: fill #FFFFFF, stroke #747775, text #1F1F1F, Roboto Medium 14/20.
 * @see https://developers.google.com/identity/branding-guidelines
 */
export default function GoogleSignInButton({
  href,
  label = 'Sign in with Google',
  style,
  ...rest
}: {
  href: string;
  label?: 'Sign in with Google' | 'Sign up with Google' | 'Continue with Google';
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a
      href={href}
      rel="noopener noreferrer"
      className="google-signin-btn"
      style={{ ...baseStyle, ...style }}
      {...rest}
    >
      {/* Official Google "G" logo (standard color) per branding guidelines */}
      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
          fill="#4285F4"
        />
        <path
          d="M9 18c2.43 0 4.467-.806 6.168-2.172l-2.908-2.258c-.806.54-1.837.86-3.26.86-2.504 0-4.63-1.69-5.512-4.06H.639v2.332C2.33 15.98 5.495 18 9 18z"
          fill="#34A853"
        />
        <path
          d="M3.456 10.756c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V6.714H.64C.077 7.89 0 9.22 0 10.644c0 1.422.077 2.754.64 3.93l2.817-2.218z"
          fill="#FBBC05"
        />
        <path
          d="M9 3.58c1.414 0 2.677.486 3.683 1.418l2.763-2.764C13.463.891 11.426 0 9 0 5.495 0 2.33 2.02.64 5.258L3.456 7.59C4.37 5.27 6.496 3.58 9 3.58z"
          fill="#EA4335"
        />
      </svg>
      <span>{label}</span>
    </a>
  );
}
